import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@coolblue-development/freddy';
import reserveItemInAStoreTrigger from '@coolblue-development/ga4-events/triggers/StoreStockOverlay/reserveItemInAStoreTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useClientLogger } from '@coolblue-development/next-config/client';
import { useState } from 'react';
import { addProductToShoppingCart, setStockLocationUrl } from '../../../actions/index.js';
import { useStoreAvailability } from '../../../context/StoreAvailabilityContext.js';
import { useTranslation } from '../../../i18n/useTranslation.js';
export const AddToCartButton = () => {
    const { stockLocationId, store, productId } = useStoreAvailability();
    const logger = useClientLogger();
    const { trackEvent } = useAnalytics();
    const { t } = useTranslation('storesStockOverlay');
    const [isLoading, setIsLoading] = useState(false);
    const trackAddToCart = () => {
        var _a;
        trackEvent(reserveItemInAStoreTrigger({
            sub_feature: 'generic_store_stock_overlay',
            store_id: Number(stockLocationId),
            store_name: (_a = store === null || store === void 0 ? void 0 : store.name) !== null && _a !== void 0 ? _a : '',
            item_id: productId,
        }));
    };
    const onAddToCartButtonClick = (productId, stockLocationId) => async () => {
        setIsLoading(true);
        try {
            await addProductToShoppingCart({
                products: [{ productId, quantity: 1 }],
            });
            trackAddToCart();
            const { redirectUrl } = await setStockLocationUrl(stockLocationId);
            if (redirectUrl) {
                window.location.assign(redirectUrl);
            }
        }
        catch (error) {
            logger.error('Add to cart flow failed:', error);
        }
        finally {
            setIsLoading(false);
        }
    };
    return (_jsx(Button, { mt: 300, onClick: onAddToCartButtonClick(productId.toString(), stockLocationId.toString()), loading: isLoading, variant: "action", children: t('addToCart') }));
};
//# sourceMappingURL=AddToCartButton.js.map